import React from 'react'
import FormatCurrency from 'components/Common/FormatCurrency/FormatCurrency'
import { pluralizeToString } from 'lib/string/pluralize'
import PriceRowCaption from 'components/Luxkit/PricePoints/PriceRowCaption'
import LuxPlusPriceStack from 'luxPlus/components/LuxPlusPriceStack'
import PriceRowPrice from 'components/Luxkit/PricePoints/PriceRowPrice'
import { PackageOptionUpgradeView } from './PackageUpgradeModal'
import getPackageUpgradePrice from './getPackageUpgradePrice'

interface Props {
  packageUpgrade: PackageOptionUpgradeView;
  hasFlightsSelected?: boolean;
}

function LePackageUpgradePrice({
  packageUpgrade,
  hasFlightsSelected,
}: Props) {
  const { total, isSamePrice, price, memberPrice, duration } = getPackageUpgradePrice(packageUpgrade, hasFlightsSelected)

  return <div>
    {isSamePrice && <PriceRowPrice
      size="M"
      price={price}
      signDisplay="always"
      saleUnit=""
    />}
    {!isSamePrice && <LuxPlusPriceStack
      size="M"
      price={price}
      memberPrice={memberPrice}
      signDisplay="always"
      saleUnit=""
      offerConfig={packageUpgrade.offer.luxPlus}
    />}
    <PriceRowCaption>
      <FormatCurrency value={total}/> total for {pluralizeToString('night', duration)}
    </PriceRowCaption>
  </div>
}

export default LePackageUpgradePrice
